import { IVideoStudiosContext, IFilterValues } from './videoStudiosContext';

export enum VideoStudiosActionTypes {
	SET_VIDEO_STUDIOS = 'SET_VIDEO_STUDIOS',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	SET_ID_FOR_EDIT = 'SET_ID_FOR_EDIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
	REFETCH_STUDIOS = 'REFETCH_STUDIOS',
}

interface ISetVideoStudios {
	type: VideoStudiosActionTypes.SET_VIDEO_STUDIOS;
	payload: {
		videoStudios: IVideoStudiosContext['videoStudios'];
		typeOfModalWindow: IVideoStudiosContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: VideoStudiosActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IVideoStudiosContext['searchString'];
	};
}

interface IResetSelectedControls {
	type: VideoStudiosActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: VideoStudiosActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IVideoStudiosContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: VideoStudiosActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IVideoStudiosContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: VideoStudiosActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IVideoStudiosContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: VideoStudiosActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IVideoStudiosContext['IDForDeletion'];
		typeOfModalWindow: IVideoStudiosContext['typeOfModalWindow'];
	};
}

interface ISetIDForEdit {
	type: VideoStudiosActionTypes.SET_ID_FOR_EDIT;
	payload: {
		IDForEdit: IVideoStudiosContext['IDForEdit'];
		typeOfModalWindow: IVideoStudiosContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfVideoStudiosModalWindow {
	type: VideoStudiosActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IVideoStudiosContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: VideoStudiosActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

interface IRefetchStudios {
	type: VideoStudiosActionTypes.REFETCH_STUDIOS;
	payload: {
		needRefetchStudios: IVideoStudiosContext['needRefetchStudios'];
	};
}

export type TVideoStudiosAction =
	| ISetVideoStudios
	| IChangeSearchString
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| ISetIDForEdit
	| IChangeTypeOfVideoStudiosModalWindow
	| ISetFiltersFromQueryString
	| IRefetchStudios;
